// Text for the upload tray and download progress (TransferProgressToast),
// kept apart from the component so it can be tested without mounting anything.

// How many failed file names the toast lists before summarising the rest.
export const MAX_LISTED_NAMES = 3;

export function uploadMessage({ active, done, failed, cancelled = 0, total, percent }) {
  if (active) return `กำลังอัปโหลด ${done} จาก ${total} ไฟล์ · ${percent}%`;
  if (cancelled > 0) {
    return done > 0
      ? `ยกเลิกแล้ว · อัปโหลดสำเร็จ ${done} จาก ${total} ไฟล์`
      : "ยกเลิกการอัปโหลดแล้ว";
  }
  if (failed > 0) {
    return done > 0
      ? `อัปโหลดสำเร็จ ${done}/${total} ไฟล์ ไม่สำเร็จ ${failed} ไฟล์`
      : `อัปโหลดไม่สำเร็จ ${failed} ไฟล์`;
  }
  return `อัปโหลดเสร็จ ${done} ไฟล์`;
}

export function downloadMessage({ done, total, percent, phase }) {
  if (phase === "zip") return `กำลังรวม ${total} ไฟล์เป็น zip...`;
  if (total > 1) return `กำลังดาวน์โหลด ${done}/${total} ไฟล์`;
  return percent > 0 ? `กำลังดาวน์โหลด · ${percent}%` : "กำลังดาวน์โหลด...";
}

/**
 * "a, b, c และอีก 2 ไฟล์" — the failed files a user has to look for.
 * Returns "" when there is nothing to name.
 */
export function failedNamesSummary(names, max = MAX_LISTED_NAMES) {
  const list = (names || []).filter(Boolean);
  if (list.length === 0) return "";
  const shown = list.slice(0, max).join(", ");
  const rest = list.length - max;
  return rest > 0 ? `${shown} และอีก ${rest} ไฟล์` : shown;
}

/** One tray row's status: "รอคิว", "42%", "เสร็จ", "ไม่สำเร็จ"… */
export function rowStatusText({ state, reason, loaded = 0, size = 0 }) {
  switch (state) {
    case "queued":
      return "รอคิว";
    case "uploading":
      return size ? `${Math.min(99, Math.round((loaded / size) * 100))}%` : "กำลังส่ง";
    case "uploaded":
      return "กำลังบันทึก";
    case "done":
      return "เสร็จ";
    case "failed":
      if (reason === "cancelled") return "ยกเลิกแล้ว";
      // The file reached storage; the server registers it on its own.
      if (reason === "server") return "บันทึกช้า รอสักครู่";
      return "ไม่สำเร็จ";
    default:
      return "";
  }
}
